import React, { useState } from "react";
import { Modal } from "./ui";

const ISSUES = [
  ["Client", "Client issue", "Something on the client's side"],
  ["Patient", "Patient issue", "Something on the patient's side"],
  ["Production", "Production issue", "Something our production team missed"],
];

export function IssueModal({ title, sub, onCancel, onConfirm, busy }) {
  const [type, setType] = useState("");
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");
  const submit = () => {
    if (!type) { setErr("Please choose whose issue this is."); return; }
    if (!reason.trim()) { setErr("Please give a reason."); return; }
    onConfirm(type, reason.trim());
  };
  return (
    <Modal locked title={title || "Whose issue is this?"}
      sub={sub || "Pick who caused it so we can report client vs patient vs production issues later."}
      onClose={onCancel}
      foot={<>
        <button className="btn btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={busy}>{busy ? <span className="spin" /> : "Confirm & send"}</button>
      </>}>
      <div className="issue-choices">
        {ISSUES.map(([v, label, hint]) => (
          <button key={v} type="button" className={"issue-choice" + (type === v ? " on" : "")} onClick={() => { setType(v); setErr(""); }}>
            <span className="issue-choice-label">{label}</span>
            <span className="issue-choice-hint">{hint}</span>
          </button>
        ))}
      </div>
      <label className="issue-reason-label">Reason <span className="req-star">(required)</span></label>
      <textarea className="inp" rows={3} placeholder="Explain the issue in your own words…" value={reason} onChange={(e) => { setReason(e.target.value); setErr(""); }} />
      {err && <div className="issue-err">{err}</div>}
    </Modal>
  );
}